import React from 'react';

const pillStyle = (active) => active
  ? { background: 'var(--accent-dim)', color: 'var(--accent)', border: '1px solid var(--border-accent)' }
  : { background: 'var(--bg-input)', color: 'var(--text-muted)', border: '1px solid var(--border-subtle)' };

/**
 * LibraryFilters — search box + tag pills for the Library page.
 * Purely presentational/controlled — all state lives in the parent.
 *
 * Category pills were removed in the 2026-08 pivot (flat recency feed). Tags
 * remain as the flexible, admin-controlled grouping axis.
 */
export default function LibraryFilters({
  search, onSearchChange,
  allTags, activeTag, onTagChange,
}) {
  return (
    <div className="space-y-4">
      <label htmlFor="library-search" className="sr-only">Search speeches</label>
      <input
        id="library-search"
        type="text"
        value={search}
        onChange={e => onSearchChange(e.target.value)}
        placeholder="Search by title or speaker…"
        className="w-full px-4 py-2.5 rounded-xl text-sm"
        style={{
          background: 'var(--bg-input)',
          border: '1px solid var(--border-subtle)',
          color: 'var(--text-primary)',
          outline: 'none',
        }}
        onFocus={e => { e.currentTarget.style.borderColor = 'var(--border-accent)'; }}
        onBlur={e => { e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
      />

      {allTags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          <button onClick={() => onTagChange(null)} className="px-3 py-1 rounded-pill text-xs font-semibold transition-all" style={pillStyle(activeTag === null)}>
            All tags
          </button>
          {allTags.map(tag => (
            <button
              key={tag}
              onClick={() => onTagChange(activeTag === tag ? null : tag)}
              className="px-3 py-1 rounded-pill text-xs font-semibold transition-all"
              style={pillStyle(activeTag === tag)}
            >
              {tag}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
